
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.94 5L.756 1.818a.75.75 0 111.06-1.06L5 3.938 8.182.757a.75.75 0 111.06 1.061L6.062 5l3.182 3.182a.75.75 0 01-1.061 1.06L5 6.062 1.818 9.243a.75.75 0 01-1.06-1.061L3.938 5z","fill":"#808393"}})])
          )
        }
      }
    